import { render, staticRenderFns } from "./wait_buy_order.vue?vue&type=template&id=c03d5750&"
import script from "./wait_buy_order.vue?vue&type=script&lang=js&"
export * from "./wait_buy_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports